export default __webpack_public_path__ + "asset/img/live-bg~23c6e17a.png";